import React from "react";
import SportenOpHetWerkForm from "./SportenOpHetWerkForm";
import AutoBindComponent from "../common/AutoBindComponent";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ajaxActions from "../../actions/ajaxCounterActions";
import SportenOpHetWerkPageHelper from "./SportenOpHetWerkPageHelper";
import SportenOpHetWerkBevestegingForm from "./SportenOpHetWerkBevestigingForm";
import Section from "../common/Section";
import * as types from "../../constants/ComponentConstants";
import { withRouter } from 'react-router-dom'

class SportenOpHetWerkPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            sportenOpHetWerkModel: {
                initiatieven: [],
                hoofdzetel: {
                    ondernemingsnummer: "",
                    bedrijfnaam: "",
                    emailBedrijf: "",
                    adres: {
                        straat: "",
                        huisnummer: "",
                        bus: "",
                        postcode: null,
                        gemeente: null
                    }
                },
                aanvraagAdresVestiging: {
                    isNotIdem: false,
                    adres: {
                        straat: "",
                        huisnummer: "",
                        bus: "",
                        postcode: null,
                        gemeente: null
                    }
                },
                contactPersoon: {
                    voornaam: "",
                    familienaam: "",
                    email: "",
                    bevestigingEmail: "",
                    gsm: "",
                    telefoon: ""
                },
                bedrijfInfo: {
                    aantalWerknemers: "",
                    vestiging: "",
                    profitNonProfit: null,
                    sector: null,
                    preventieDienst: null,
                    aangeslotenBij: null
                },
                opmerking: ""
            },
            errors: [],
            sent: false
        };

        this.pageHelper = new SportenOpHetWerkPageHelper(this);
    }


    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    }

    handleOnChange = (event) => this.pageHelper.change(event);
    handleChangeInitiatieven = (event) => this.pageHelper.changeInitiatieven(event);
    handleOnChangeHoofdZetel = (event) => this.pageHelper.changeHoofdZetel(event);
    handleOnChangeHoofdzetelAdres = (event) => this.pageHelper.changeHoofdZetelAdres(event);
    handleCheckboxChange = (event) => this.pageHelper.changeCheckbox(event);
    handleAanvraagAdresVestiging = (event) => this.pageHelper.changeAanvraagAdresVestiging(event);
    handleOnChangeContactPersoon = (event) => this.pageHelper.changeContactPersoon(event);
    handleOnChangeBedrijfInfo = (event) => this.pageHelper.changeBedrijfInfo(event);
    handleOnSave = (event) => this.pageHelper.onSave();
    render() {
        return (
            <Section title={"Vraag een initiatief aan"} color={types.COLOR_BLUE}>
                {this.state.sent ?
                    <SportenOpHetWerkBevestegingForm /> :
                    <SportenOpHetWerkForm
                        model={this.state.sportenOpHetWerkModel}
                        onChange={this.handleOnChange}
                        onChangeInitiatieven={this.handleChangeInitiatieven}
                        onChangeHoofdZetel={this.handleOnChangeHoofdZetel}
                        onChangeHoofdzetelAdres={this.handleOnChangeHoofdzetelAdres}
                        onChangeCheckbox={this.handleCheckboxChange}
                        onChangeAanvraagAdres={this.handleAanvraagAdresVestiging}
                        onChangeContactPersoon={this.handleOnChangeContactPersoon}
                        onChangeBedrijfInfo={this.handleOnChangeBedrijfInfo}
                        onSave={this.handleOnSave}
                        errors={this.state.errors}
                    />
                }
            </Section>

        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        postcodes: state.referentie.postcodes,
        gemeentes: state.referentie.gemeentes,
        preventieDiensten: state.referentie.preventieDiensten,
        profitNonProfits: state.referentie.profitNonProfits,
        sectoren: state.referentie.sectoren,
        aangeslotenBijs: state.referentie.aangeslotenBijs,
        initiatievenList: state.referentie.initiatieven
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SportenOpHetWerkPage));